<mat-toolbar class="default-margin-bottom">
  <h2>Gym Finder Admin</h2>
  @if (loading) {
    <mat-spinner [diameter]="30"></mat-spinner>
  }
</mat-toolbar>
<ngx-adm-int-error [error]="error"></ngx-adm-int-error>

<!-- =============================================================== -->
<!-- Gym importing functionality if URL referenced id does not exist -->
<!-- =============================================================== -->
@if (!gym && !loading) {
  <gymfinder-gym-import
    [gymId]="gymId"
  (gymChange)="onGymChange($event)"></gymfinder-gym-import>
}

<!-- =============================================================== -->
<!-- Gym managing functionality if URL referenced id exists          -->
<!-- =============================================================== -->
@if (gym) {
  <div>
    @if (gymUpdatedAt && expectedLiveAt) {
      @if (isPropagationWindowElapsed) {
        <gymfinder-alert variant="warning" class="default-margin-bottom">
          <span>
            This gym was updated at
            <strong>{{ gymUpdatedAt | date: 'medium' }}</strong>. Changes should already be live.
          </span>
        </gymfinder-alert>
      } @else {
        <gymfinder-alert variant="info" class="default-margin-bottom">
          <span>
            This gym was updated at
            <strong>{{ gymUpdatedAt | date: 'medium' }}</strong>. Changes may
            take up to 1 hour to appear. Check back after
            <strong>{{ expectedLiveAt | date: 'medium' }}</strong> to confirm
            they're live.
          </span>
        </gymfinder-alert>
      }
    }
    <mat-card class="default-margin-bottom">
      <mat-card-title class="gym-basic-info-title">
        <div class="flex-row">
          {{ gymAlias }}
          <span class="card-title-spacer"></span>
          <button
            mat-mini-fab
            class="button-bar"
            color="default"
            matTooltip="View as JSON"
            (click)="showGymDetailsJsonDialog()"
            type="button">
            <mat-icon color="secondary" aria-label="Generate payload">
              visibility
            </mat-icon>
          </button>
          @if (editMode) {
            <button
              mat-mini-fab
              class="button-bar sync-spacer"
              color="default"
              matTooltip="Sync Gym Location"
              (click)="syncGym()"
              type="button">
              <mat-icon color="secondary" aria-label="Sync Location">sync</mat-icon>
            </button>
          }
        </div>
      </mat-card-title>
      <mat-card-content>
        <gymfinder-gym-info [gym]="gym"></gymfinder-gym-info>
      </mat-card-content>
    </mat-card>
    <form #gymForm="ngForm">
      @if (!!gym && !loading) {
        <div>
          <nav mat-tab-nav-bar [tabPanel]="tabPanel" mat-stretch-tabs="true">
            @for (tab of tabs; track tab) {
              <div>
                <a
                  mat-tab-link
                  [routerLink]="tab.route"
                  [active]="tab.internalRoute === internalRoute">
                  {{ tab.label }}
                </a>
              </div>
            }
          </nav>
          <mat-tab-nav-panel #tabPanel>
            <router-outlet></router-outlet>
          </mat-tab-nav-panel>
          <div>
            @switch (internalRoute) {
              @default {
                <gymfinder-gym-details
                  [gym]="gym"
                  [loading]="loading"
                  [gymAlias]="gymAlias"
                  [studioTypes]="studioTypes"
                  [editMode]="editMode"
                  [gymSavedSubject]="gymSavedSubject"
                  [displayGymlibBackOfficeLink]="displayGymlibBackOfficeLink"
                [creditsFeatureFlag]="creditsFeatureFlag"></gymfinder-gym-details>
              }
              @case (InternalRoutes.IMAGES) {
                <gymfinder-gym-image
                  [(gym)]="gym"
                [(updatingImages)]="updatingImages"></gymfinder-gym-image>
              }
              @case (InternalRoutes.CLASS_BOOKING) {
                <div>
                  @if (!gym.gymUUID || !gym.network) {
                    <gymfinder-alert
                      variant="warning"
                      class="alert-margin-top"
                      >
                      <span>
                        <strong>Warning:</strong> Missing required information:
                        <em>Gym UUID</em> or <em>Network</em>. Please update or
                        synchronize the gym.
                      </span>
                    </gymfinder-alert>
                  }
                  <gymfinder-access-config
                    [gymUUID]="gym.gymUUID"
                    [tanAccountCreationEnabled]="
                      gym.tanAccountCreationEnabled ?? false
                    "
                    [classBookingConfig]="gym.classBookingConfig"
                    [geofence]="gym.geofence"
                    (accessConfigChanged)="onAccessConfigChanged($event)">
                  </gymfinder-access-config>
                </div>
              }
              @case (InternalRoutes.CHECKIN_ATTEMPTS) {}
            }
          </div>
        </div>
      }
      @if (editMode) {
        <div class="btn-float">
          @if (loading || updatingImages) {
            <mat-spinner
              [diameter]="48"
            style="display: inline-block"></mat-spinner>
          }
          @if (
            !loading &&
            !updatingImages &&
            internalRoute !== InternalRoutes.CLASS_BOOKING &&
            internalRoute !== InternalRoutes.CHECKIN_ATTEMPTS
            ) {
            <button
              (click)="saveGym()"
              mat-fab
              color="primary"
              type="button"
              matTooltip="Save Gym">
              <mat-icon>save</mat-icon>
            </button>
          }
        </div>
      }
    </form>
  </div>
}
